<template lang="pug">
page(
    main-title="Настройки служб доставки",
    :links="[{component: 'DeliveryServices', title: 'Службы доставки'}, 'Настройки службы доставки']"
)
    template(slot="description") Настройки службы доставки
        b  {{ editedDeliveryService.name }}
    .panel
        .panel-body
            .row(v-if="!editedDeliveryService.manual")
                .col-md-6.margin-bottom-30
                    template(v-for="(field_config, fieldName) in editedFields")
                        field(
                            :type="field_config.type || 'text'"
                            :label="field_config.label"
                            :item="editedItem[fieldName]"
                        )
                    .checkbox.clip-check.check-primary.checkbox-inline
                        input(
                            id="with_acquiring_commission_input"
                            type="checkbox",
                            v-model="editedItem.with_acquiring_commission"
                        )
                        label(for="with_acquiring_commission_input") Учитывать комиссию за наложенный платёж при расчёте стоимости доставки
                    .checkbox.clip-check.check-primary.checkbox-inline
                        input(
                            id="with_insurance_commission_input"
                            type="checkbox",
                            v-model="editedItem.with_insurance_commission"
                        )
                        label(for="with_insurance_commission_input") Учитывать комиссию за страховку при расчёте стоимости доставки

            p Можно задать <b>название способа доставки</b> для отображения в виджете
                | (например, для способа доставки <i>Самовывоз Pickpoint «Оптимальный 2018» стандарт</i>
                | можно в виджете показывать просто <i>Самовывоз Pickpoint</i>).

            p Кроме того, можно задать число для <b>сортировки</b> способа доставки при отображении в виджете
                | (чем больше число, тем выше будет способ доставки).

            .row(v-for="deliveryMethod in editedItem.delivery_methods")
                .col-md-5(style="padding-top: 8px; padding-bottom: 8px;")
                    span.help-inline {{ deliveryMethod.name }}
                .col-md-5.col-xs-8
                    field(
                        label="Название в виджете",
                        :item="deliveryMethod.widget_name"
                    )
                .col-md-2.col-xs-4
                    field(
                        type="number",
                        label="Сортировка",
                        :item="deliveryMethod.order_by",
                        @focus="() => { deliveryMethod.order_by.value = deliveryMethod.order_by.value || null }",
                        @blur="() => { deliveryMethod.order_by.value = Number(deliveryMethod.order_by.value) || 0 }"
                    )

            button.btn.btn-o.btn-primary(@click.prevent="save") Сохранить
            button.btn.btn-o.btn-primary.pull-right(@click.prevent="discard") Отмена

</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

const API_KEY_FIELD = {
    api_token: {label: 'API-ключ службы доставки', type: 'text'}
};

const FIELD_PRESETS = {
    boxberry: API_KEY_FIELD,
    grastin: API_KEY_FIELD,
    sdek: {
        account: {label: 'Идентификатор клиента СДЭК (Account)', type: 'text'},
        secure_password: {label: 'Ключ (Secure password)', type: 'text'}
    },
    dpd: {
        login: {label: 'Логин клиента DPD', type: 'text'},
        ...API_KEY_FIELD
    },
    post: {
        careful: {label: 'Отметка «Осторожно» для посылок', type: 'checkbox'},
        sms: {label: 'СМС информирование', type: 'checkbox'}
    },
    pickpoint: {
        ikn: {
            label: 'ИКН (номер договора)',
            type: 'text'
        },
        login: {
            label: 'Логин',
            type: 'text'
        },
        password: {
            label: 'Пароль',
            type: 'text'
        }
    }
};

export default {
    name: 'EditDeliveryService',
    created() {
        if (!this.editedDeliveryService.id) {
            this.$router.push({name: 'DeliveryServices'});
        }
    },
    methods: {
        getInitial() {
            let item = this.editedDeliveryService;

            item.config = item.config || {};
            for (let field in this.editedFields) {
                item[field] = {
                    value: item.config[field],
                    valid: true,
                    message: null
                };
            }

            item.delivery_methods = item.delivery_methods || [];
            for (let deliveryMethod of item.delivery_methods) {
                deliveryMethod.widget_name = {
                    value: deliveryMethod.widget_name,
                    valid: true,
                    message: null
                };
                deliveryMethod.order_by = {
                    value: deliveryMethod.order_by,
                    valid: true,
                    message: null
                };
            }

            return item;
        },
        getValues() {
            let item = cloneDeep(this.editedItem);

            item.config = item.config || {};
            for (let field in this.editedFields) {
                item.config[field] = item[field].value;
            }

            for (let deliveryMethod of item.delivery_methods) {
                deliveryMethod.widget_name = deliveryMethod.widget_name.value;
                deliveryMethod.order_by = deliveryMethod.order_by.value;
            }

            return item;
        },
        save() {
            this.$store.dispatch('saveDeliveryServiceSetting', this.getValues())
                .then(() => {
                    this.$router.push({name: 'DeliveryServices'});
                });
        },
        discard() {
            this.$router.push({name: 'DeliveryServices'});
        }
    },
    data() {
        this.editedDeliveryService = cloneDeep(this.$store.state.deliveryServices.editedDeliveryService);

        this.editedFields = FIELD_PRESETS[this.editedDeliveryService.code] || {};

        let item = this.getInitial();

        return {
            editedItem: item
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/deliveryServices/EditDeliveryService.vue